import { DataType } from "../types";
export const countStatus = (
  all: DataType[],
  passCount: number,
  underReviewCount: number
) => {
  const passedTaskIds = new Set<number>();

  all.forEach((application: DataType | any) => {
    if (application.isPassed) {
      if (!passedTaskIds.has(application.taskId)) {
        passCount++;
        passedTaskIds.add(application.taskId);
      }
    }
    if (application.approvalDate === null) {
      underReviewCount++;
    }
  });
  return {
    passCount: passCount,
    underReviewCount: underReviewCount,
  };
};
